import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { PersonasFisica } from './entity-personas-fisica.model';
import {
  Error,
  ErrorEstandar
} from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityPersonasFisicaAdapter: EntityAdapter<PersonasFisica> =
  createEntityAdapter<PersonasFisica>({
    selectId: (model) => model.id,
    sortComparer: (a: PersonasFisica, b: PersonasFisica): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityPersonasFisicaState extends EntityState<PersonasFisica> {
  isLoading?: boolean;
  error?: ErrorEstandar | null;
}

export const initialState: EntityPersonasFisicaState =
  entityPersonasFisicaAdapter.getInitialState({
    isLoading: false,
    error: null
  });
